// extracted by css-extract-rspack-plugin
export default {"custom":"CalculatorCustom-module__custom--A4X_N","header":"CalculatorCustom-module__header--BVxwN","heading":"CalculatorCustom-module__heading--fJZej"};